<app-payment-request-form (accountSubmitEmitter)="onAccountSubmission($event)"
                          [isQuickPay]="isQuickPay"
                          acceptButtonText="Next"
                          mode="create"></app-payment-request-form>
<ngx-ui-loader></ngx-ui-loader>
